export const activeStyle = {
  borderColor: '#24a7da',
  backgroundColor: '#24a7da09',
};

export const acceptStyle = {
  borderColor: '#00e676',
  backgroundColor: '#00e67609',
};

export const rejectStyle = {
  borderColor: '#ff1744',
  backgroundColor: '#ff174409',
};
